<template>
    <div class="analysis-main">
        <AnalysisNavbar></AnalysisNavbar>
        <router-view :workshops="workshops" :year="year"/>
    </div>
</template>

<script>
import AnalysisNavbar from './components/navbar.vue';
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';

export default {
    components: {
        AnalysisNavbar
    },
    data() {
        return {
            workshops: [{ name: this.$t('all'), ws_id: 0 }],
            year: new Date().getFullYear()
        };
    },
    mounted() {
        //获得所有的车间
        Axios.get(AxiosUrl.workshop.select, {
            params: {
                cid: this.$store.state.user.cid
            }
        }).then(res => {
            if (res.data.code == 200) {
                this.workshops = res.data.data;
                this.workshops.unshift({ name: this.$t('all'), ws_id: 0 });
            } else {
                console.log(res.data.msg);
            }
        });
    }
};
</script>


// WEBPACK FOOTER //
// src/views/analysis/analysis.vue